/**
 * postProcessConfig.js
 *
 * Central, tunable config for the Shimmering Prism background post-process pass
 * (level adjustment / black lift → chromatic aberration → film noise). Applies ONLY
 * to the WebGL background canvas — never the HTML UI.
 *
 * NOTE on where values live:
 *   - The three *per-section* knobs (blackLift, chromaticAberrationPx, filmNoiseAmount) live in
 *     SECTION_PRESETS inside ShimmeringPrism.js, alongside the other per-section look params, so they
 *     crossfade with the homepage section scroll (and show up in the ?debug panel). Tune them there.
 *   - This file holds the *global* switches / rates and the (not-yet-wired) manifesto target.
 *
 * Debug control ranges (see debug.js):
 *   blackLift             0.000 – 0.050  step 0.001
 *   chromaticAberrationPx 0.000 – 2.000  step 0.01
 *   filmNoiseAmount       0.000 – 0.100  step 0.001
 */

export const POST_PROCESS = {
    /** Master switch. false → the background renders straight to screen (exact prior behaviour, no RT). */
    enabled: true,
    /** Grain animation time-scale (the legacy grain reference used 10.0). Higher = faster grain motion. */
    filmNoiseSpeed: 10,
};

/**
 * Stronger post-process values for the manifesto hold/active state. NOT wired yet — the manifesto
 * hold (HomeHero.js) currently drives the legacy Sketch via SketchContext, which is null in shimmer
 * mode. ShimmeringPrism.setManifestoActive(active) tweens this.params toward these values; a later
 * phase can call it from a manifesto pub/sub bridge (see NEXT_STEPS.md). Subtle by intent.
 */
export const POST_PROCESS_MANIFESTO = {
    blackLift: 0.028,            // 0.02 – 0.035 range
    chromaticAberrationPx: 1.2,  // 1.0 – 1.5 range
    filmNoiseAmount: 0.055,      // 0.04 – 0.07 range
};
